import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Backdrop, Box, Button } from '@mui/material';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import CheckPermissions from '../../../authorization/authorization';
import AdminCompanySelect from '../../../components/AdminCompanySelect/AdminCompanySelect';
import BasicTable from '../../../components/basicTable/basicTable';
import { cfpBaseUrl } from '../../../network/urls';
import { companyShortName, companyShortName1, convertDatewithTime } from '../../../services/Functions';
import { tableStyle } from '../../../style/common';
import useAdminOrgCompanyFilter from '../hooks/useAdminOrgCompanyFilter';
import '../OrganizationManagement.scss';
import '../OrgEntityDetailsDialog.scss';
import SearchIcon from '@mui/icons-material/Search';

const displayValue = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    return String(value);
};

const formatDetailDate = (dateValue) => {
    if (dateValue === null || dateValue === undefined || dateValue === '') return '-';
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime()) || date.getFullYear() < 1971) return '-';
    return convertDatewithTime(dateValue);
};

const isCircleActive = (status) => status === '0' || status === 'active';

const isCircleStore = (isStore) => isStore === '1' || isStore === 'Yes';

const DetailField = ({ label, value }) => {
    const text = displayValue(value);
    return (
        <div className="org-details-dialog__field">
            <span className="org-details-dialog__label">{label}</span>
            <p className={`org-details-dialog__value${text === '-' ? ' org-details-dialog__value--muted' : ''}`}>
                {text}
            </p>
        </div>
    );
};

const DetailSection = ({ title, children }) => (
    <section className="org-details-dialog__section">
        <div className="org-details-dialog__section-header">
            <span className="org-details-dialog__section-accent" />
            <h4>{title}</h4>
        </div>
        <div className="org-details-dialog__grid">{children}</div>
    </section>
);

export default function CircleManagementTable(props) {
    //#region 
    const [circlesToDataGrid, setCirclesToDataGrid] = useState([]);
    const [open, setOpen] = useState(false);
    const [open2, setopen2] = useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [dltCircle, setDltCircle] = useState()
    const [tableCircles, setTableCircles] = useState([]);
    const Navigate = useNavigate();
    const [viewBackdrop, setViewBackdrop] = useState(true);
    const [tableDataLoaded, setTableDataLoaded] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const { token, code: userOfficeCode, permissions } = useSelector((state) => state.auth)
    const {
        isAdminUser,
        selectedCompanyCode,
        handleChangeCompany,
        getCircleApiCompanyCode,
    } = useAdminOrgCompanyFilter();

    //#endregion
    useEffect(() => {
        if (!tableDataLoaded) return;
        apiToDataGridConversion();
        setViewBackdrop(false);
    }, [tableCircles, tableDataLoaded]);

    useEffect(() => {
        const callAllCirclesAPI = async () => {
            setViewBackdrop(true);
            setTableDataLoaded(false);

            const companyCode = getCircleApiCompanyCode();
            if (companyCode === null) {
                setTableCircles([]);
                setTableDataLoaded(true);
                return;
            }

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                companyCode,
                pageNumber: 1,
                pageSize: 9999,
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };
            await fetch(cfpBaseUrl + "customerFaciliationPortal/getCirclesDetails", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        setTableCircles(result.data);
                    } else if (result.status === "401" && result.message === "Session has been expired, Sign in again.") {
                        Navigate('/')
                    } else {
                        setTableCircles([]);
                    }
                })
                .catch(() => {
                    setTableCircles([]);
                });
            setTableDataLoaded(true);
        }
        callAllCirclesAPI()
    }, [selectedCompanyCode, userOfficeCode])

    const filterCircle = (circleCode) => {
        let itemFound = tableCircles.find(item => item.circleCode === circleCode)
        return itemFound;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setopen2(false);
    };

    const onDelete = async () => {
        var formdata = new FormData();
        formdata.append("circleCode", dltCircle);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/deleteCircle", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let myArray = [...tableCircles]
                    let index = myArray.findIndex(obj => obj.circleCode == dltCircle);
                    if (index != -1) {
                        myArray.splice(index, 1);
                        setTableCircles(myArray)
                    }
                }
                else {
                }
            })
            .catch(() => {});
        handleClose2();
    }

    const tblColumns = [
        { field: "id", headerName: 'Code', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "completename", headerName: 'Circle Name', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "companyname", headerName: 'Company Name', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "created_by", headerName: 'Creator', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "created_at", headerName: 'Created', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "updated_by", headerName: 'Updator', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "updated_at", headerName: 'Updated', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "bank_name", headerName: 'Bank Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "erp_code", headerName: 'ERP Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "capital_code", headerName: 'Cap. Cost Acc. No.', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "security_code", headerName: 'Sec. Cost Acc. No.', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            headerName: "Action",
            sortable: false,
            field: 'buttons',
            headerAlign: 'center',
            align: 'center',
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => {
                const onViewCircle = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const item = filterCircle(params.id);
                    setDialogRowData(item);
                    setOpen(true);
                };
                const onDeleteCircle = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setopen2(true);
                    setDltCircle(params.id)
                }
                const onEditCircle = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const circleToEdit = filterCircle(params.id);
                    Navigate('/circle-management/update-circle', { state: { circleToEdit } })
                }
                return (
                    <>
                        <Box>
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Circle Management', 'Read') ?
                                    <IconButton onClick={onViewCircle} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
                                        <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
                                    </IconButton> : null
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Circle Management', 'Update') ?
                                    <IconButton onClick={onEditCircle} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
                                        <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
                                    </IconButton> : null
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Circle Management', 'Delete') ?
                                    <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteCircle}>
                                        <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
                                    </IconButton> : null
                            }
                        </Box>
                    </>
                )
            }
        }
    ]

    const apiToDataGridConversion = () => {
        const myArray = tableCircles
        const tempArray = []
        if (myArray) {
            //for(let i = 0; i <= myArray.length; i++){
            myArray.forEach((item) => {
                const dataGridObject = {
                    "id": item.circleCode ? item.circleCode : '-',
                    "completename": item.circleName ? item.circleName : '-',
                    "roles": item.roleName ? item.roleName : '-',
                    // "created_by": item.createdBy ? item.createdBy : '-',
                    // "created_at": item.createdDate ? convertDate(item.createdDate) : '-',
                    // "updated_by": item.updateBy ? item.updateBy : '-',
                    // "updated_at": item.updatedDate ? convertDate(item.updatedDate) : '-',
                    "bank_name": item.circleBankName ? item.circleBankName : '-',
                    "companyname": companyShortName(item.companyCode.toString()),
                    "erp_code": item.circleErpCode ? item.circleErpCode : '-',
                    "capital_code": item.circleCapitalCostAccountNo ? item.circleCapitalCostAccountNo : '-',
                    "security_code": item.circleSecurityAccountNo ? item.circleSecurityAccountNo : '-'
                }
                tempArray.push(dataGridObject)
            })
        }
        else {
            const dataGridObject = {
                "id": ' ',
                "completename": ' ',
                "roles": ' ',
                "created_by": ' ',
                "created_at": ' ',
                "updated_by": ' ',
                "updated_at": ' ',

            }
            tempArray.push(dataGridObject)
        }
        setCirclesToDataGrid(tempArray);
        setFilteredData(tempArray);
    }
    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchQuery(value);

        if (!value) {
            setFilteredData(circlesToDataGrid);
            return;
        }

        const filtered = circlesToDataGrid.filter((row) =>
            row.id?.toString().toLowerCase().includes(value) ||
            row.completename?.toLowerCase().includes(value) ||
            row.companyname?.toLowerCase().includes(value) 
        );

        setFilteredData(filtered);
    };
    return (
        <>
            <Box className='form-box org-management-list'>
                {/* <Box className='main-heading'>
                    <h2>
                        Circle Management
                    </h2>
                    <div className='btn2'>
                        {
                            CheckPermissions(permissions,'Organization Management', 'Circle Management', 'Create') &&
                            < Link to="/circle-management/new-circle">
                                <Button variant="contained" size='small' className='btnNewApplication' startIcon={<AddCircleIcon />} sx={{ textTransform: 'capitalize' }} >
                                    Create Circle
                                </Button>
                            </Link>
                        }
                    </div>
                </Box> */}
                <Box className="mgmt-page-header">
                    <div className="mgmt-page-header__leading">
                        <h3 className="page-title">Circle Management</h3>
                        {isAdminUser && (
                            <AdminCompanySelect
                                value={selectedCompanyCode}
                                onChange={handleChangeCompany}
                                minWidth={180}
                                includePitc={false}
                                restrictToEnabled={false}
                            />
                        )}
                    </div>
                    <div className="mgmt-table-search">
                        <span className="mgmt-table-search__badge" aria-hidden="true">
                            <SearchIcon className="mgmt-table-search__icon" />
                        </span>
                        <input
                            type="text"
                            className="mgmt-table-search__input"
                            value={searchQuery}
                            onChange={handleSearch}
                            placeholder="Search by Code, Circle Name or Company Name"
                            maxLength={20}
                            aria-label="Search circles"
                        />
                    </div>
                </Box>
                <Box className='application-table'>
                    <BasicTable
                        data={filteredData}
                        columns={tblColumns}
                        rowHeight={37.5}
                        pageSize={18}
                        rowsPerPageOptions={[18, 30, 60]}
                        rowsPageOption={false}
                        sx={tableStyle}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow;
                        }}
                    />
                </Box>
            </Box>


            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                className="alert-popups org-details-dialog"
                aria-labelledby="circle-details-dialog-title"
            >
                <DialogTitle
                    id="circle-details-dialog-title"
                    component="div"
                    className="dialog-title"
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <span className="org-details-dialog__title-text">Circle Details</span>
                    <IconButton
                        onClick={handleClose}
                        size="small"
                        aria-label="Close circle details"
                        className="org-details-dialog__close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="dialog-content">
                    <div className="org-details-dialog__body">
                        <div className="org-details-dialog__hero">
                            <div className="org-details-dialog__logo-wrap">
                                <div className="org-details-dialog__avatar" aria-hidden="true">
                                    {(dialogRowData.circleName || 'C').toString().charAt(0).toUpperCase()}
                                </div>
                            </div>
                            <div className="org-details-dialog__hero-meta">
                                <h2 className="org-details-dialog__name">
                                    {displayValue(dialogRowData.circleName)}
                                </h2>
                                <p className="org-details-dialog__code">
                                    Circle ID: <strong>{displayValue(dialogRowData.circleCode)}</strong>
                                </p>
                                <div className="org-details-dialog__badges">
                                    <span
                                        className={`org-details-dialog__status org-details-dialog__status--${
                                            isCircleActive(dialogRowData.status) ? 'active' : 'inactive'
                                        }`}
                                    >
                                        {isCircleActive(dialogRowData.status) ? 'Active' : 'Inactive'}
                                    </span>
                                    <span className="org-details-dialog__status org-details-dialog__status--neutral">
                                        Store: {isCircleStore(dialogRowData.isStore) ? 'Yes' : 'No'}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <DetailSection title="General Information">
                            <DetailField label="Latitude" value={dialogRowData.latitude} />
                            <DetailField label="Longitude" value={dialogRowData.longitude} />
                            <DetailField label="Created By" value={dialogRowData.createdBy} />
                            <DetailField label="Created At" value={formatDetailDate(dialogRowData.createdDate)} />
                            <DetailField label="Last Updated By" value={dialogRowData.updateBy} />
                            <DetailField
                                label="Last Updated At"
                                value={formatDetailDate(dialogRowData.updatedDate)}
                            />
                        </DetailSection>

                        <DetailSection title="Contact Person 1">
                            <DetailField label="Name" value={dialogRowData.cp1Name} />
                            <DetailField label="Phone" value={dialogRowData.cp1phone} />
                            <DetailField label="Mobile" value={dialogRowData.cp1Mobile} />
                            <DetailField label="Email" value={dialogRowData.cp1Email} />
                        </DetailSection>

                        <DetailSection title="Contact Person 2">
                            <DetailField label="Name" value={dialogRowData.cp2Name} />
                            <DetailField label="Phone" value={dialogRowData.cp2phone} />
                            <DetailField label="Mobile" value={dialogRowData.cp2Mobile} />
                            <DetailField label="Email" value={dialogRowData.cp2Email} />
                        </DetailSection>

                        <DetailSection title="Bank Details">
                            <DetailField label="Bank Name" value={dialogRowData.circleBankName} />
                            <DetailField label="ERP Code" value={dialogRowData.circleErpCode} />
                            <DetailField
                                label="Capital Cost Account No."
                                value={dialogRowData.circleCapitalCostAccountNo}
                            />
                            <DetailField
                                label="Security Cost Account No."
                                value={dialogRowData.circleSecurityAccountNo}
                            />
                        </DetailSection>
                    </div>
                </DialogContent>
            </Dialog>


            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {" Are you sure to delete this record"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose2}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >
        </>
    )
}
